// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OG2LgZCxbcoodLjp0tAc{align-items:center;gap:8px;display:flex}.xlDJx6NS_sjBa5c4qGCX{flex-shrink:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"timeRangeCell": `OG2LgZCxbcoodLjp0tAc`,
	"timeRangeIcon": `xlDJx6NS_sjBa5c4qGCX`
};
export default ___CSS_LOADER_EXPORT___;
